import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  PatientSmileUploadedFile,
  PatientSmileUploadClaimRequest,
  PatientSmileUploadGrant,
  PatientSmileUploadLink,
  PatientSmileUploadSession,
  PatientSmileUploadSessionRequest,
} from 'app/core/models';
import { Observable } from 'rxjs';
import { environment } from 'src/environments';

const basePath = `${environment.apiBaseUrl}patient-smile-upload`;

@Injectable({ providedIn: 'root' })
export class PatientSmileUploadApiClient {
  private readonly http = inject(HttpClient);

  createSession(request: PatientSmileUploadSessionRequest): Observable<PatientSmileUploadSession> {
    return this.http.post<PatientSmileUploadSession>(`${basePath}/sessions`, request);
  }

  createLink(sessionId: string): Observable<PatientSmileUploadLink> {
    return this.http.post<PatientSmileUploadLink>(`${basePath}/sessions/${encodeURIComponent(sessionId)}/links`, {});
  }

  claimLink(token: string): Observable<PatientSmileUploadGrant> {
    const request: PatientSmileUploadClaimRequest = { token };
    return this.http.post<PatientSmileUploadGrant>(`${basePath}/links/claim`, request);
  }

  uploadPhoto(uploadToken: string, file: File): Observable<HttpEvent<PatientSmileUploadedFile>> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<PatientSmileUploadedFile>(`${basePath}/uploads`, formData, {
      headers: new HttpHeaders({ 'X-Upload-Grant': uploadToken }),
      observe: 'events',
      reportProgress: true,
    });
  }

  getUploadedFiles(uploadToken: string): Observable<PatientSmileUploadedFile[]> {
    return this.http.get<PatientSmileUploadedFile[]>(`${basePath}/uploads`, {
      headers: new HttpHeaders({ 'X-Upload-Grant': uploadToken }),
    });
  }

  deleteUploadedPhoto(uploadToken: string, treatmentFileId: number): Observable<void> {
    return this.http.delete<void>(`${basePath}/uploads/${encodeURIComponent(treatmentFileId)}`, {
      headers: new HttpHeaders({ 'X-Upload-Grant': uploadToken }),
    });
  }
}
